module.exports = __webpack_public_path__ + "img/9791189015138.976c17b1.jpg";